export const locales = ["el", "en", "de", "fr", "es", "it", "pt"] as const;
export type MarketingLocale = typeof locales[number];
export type CoreLocale = "el" | "en";
export type Category = "getting-started" | "ai-prompts" | "cost-and-maintenance" | "business-websites" | "seo-and-domains" | "design-and-content";

export type ArticleSection = {
  heading: string;
  paragraphs: string[];
  checklist?: string[];
};
export type Article = {
  id: string;
  locale: MarketingLocale;
  slug: string;
  title: string;
  description: string;
  category: Category;
  keywords: string[];
  intro: string;
  sections: ArticleSection[];
  prompt?: string;
  takeaway: string;
  published: string;
  updated: string;
  sources?: { label: string; url: string }[];
};

/** Editorial records, not city/keyword permutations. Each record answers one distinct practical question. */
export type GuideSeed = readonly [
  slug: string, title: string, category: Category, keyword: string,
  intro: string, heading: string, advice: string,
  checklist: string, prompt: string, takeaway: string
];
